export const sports = [
  {
    id: 'golf',
    name: 'Championship Golf',
    image:
      'https://images.unsplash.com/photo-1587222318667-31212ce2828d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1587222318667-31212ce2828d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1535136104956-617ea4c68b94?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'Our 18-hole championship course offers a challenging yet rewarding experience for golfers of all skill levels, set against a backdrop of stunning natural beauty.',
    longDesc:
      'Designed by a legendary course architect, our 18-hole championship golf course is consistently ranked among the top in the region. The meticulously maintained fairways and greens wind through mature woodlands and feature strategic water hazards. We offer a full-service pro shop, extensive practice facilities including a driving range and putting green, and PGA professional coaching.',
    timings: 'Daily, 06:30 - Sunset',
    keyDetails: [
      { label: 'Course', value: '18 Holes, Par 72' },
      { label: 'Facilities', value: 'Pro Shop, Driving Range, Putting Green' },
      { label: 'Coaching', value: 'PGA Professionals available' },
    ],
  },
  {
    id: 'tennis',
    name: 'Tennis Courts',
    image:
      'https://images.unsplash.com/photo-1595435934249-5df7ed86e1c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1595435934249-5df7ed86e1c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1622279457486-62dcc4a431d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'Four pristine grass courts and two all-weather hard courts, available for casual play or professional coaching sessions.',
    longDesc:
      'Our tennis facilities cater to players of all levels year-round. During the summer months, members can enjoy our four pristine grass courts, maintained to tournament standards. For year-round play, we offer two floodlit all-weather hard courts. The club hosts regular social mixers, competitive leagues, and offers comprehensive coaching programs for adults and juniors.',
    timings: 'Daily, 07:00 - 22:00',
    keyDetails: [
      { label: 'Courts', value: '4 Grass, 2 Hard (Floodlit)' },
      { label: 'Programs', value: 'Leagues, Social Mixers, Junior Camps' },
      { label: 'Coaching', value: 'LTA Certified Coaches' },
    ],
  },
  {
    id: 'swimming',
    name: 'Aquatics Center',
    image:
      'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'A 25-meter heated indoor pool and a seasonal outdoor pool, complete with lounging areas and poolside service.',
    longDesc:
      'The Aquatics Center is a premier facility featuring a 25-meter heated indoor pool for year-round lap swimming and aqua fitness classes. During the summer, the outdoor pool opens, providing a resort-like atmosphere with comfortable sun loungers, cabanas, and dedicated poolside food and beverage service. We offer comprehensive swimming lessons for all ages and abilities.',
    timings: 'Daily, 06:00 - 21:00',
    keyDetails: [
      { label: 'Facilities', value: '25m Indoor Pool, Outdoor Leisure Pool' },
      { label: 'Classes', value: 'Aqua Aerobics, Swim School' },
      { label: 'Amenities', value: 'Sauna, Steam Room, Poolside Service' },
    ],
  },
  {
    id: 'fitness',
    name: 'Fitness & Wellness',
    image:
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'State-of-the-art gymnasium featuring the latest cardiovascular and strength training equipment, plus dedicated studios for yoga and pilates.',
    longDesc:
      'Our Fitness & Wellness center is designed to support your holistic health journey. The expansive gym floor features top-of-the-line Technogym equipment, free weights, and functional training areas. Two dedicated studios host a robust schedule of over 40 classes per week, including Yoga, Pilates, Spin, and HIIT. Our team of expert personal trainers and wellness coaches are available to create bespoke programs tailored to your goals.',
    timings: '24 Hours (Keycard Access)',
    keyDetails: [
      { label: 'Equipment', value: 'Technogym Cardio & Strength' },
      { label: 'Classes', value: '40+ Weekly Studio Classes' },
      { label: 'Services', value: 'Personal Training, Nutritional Coaching' },
    ],
  },
]

export const getSportsBySlug = (slug: string) =>
  sports.find((s) => s.id === slug)
